<!-- HIDE ON MED AND SMALL DEVICES SHOW ON LARGE -->
<mat-card-content *ngIf="sessionArr.length > 0">
    <!-- HIDE ON MED AND SMALL DEVICES SHOW ON LARGE -->
    <div class="container-fluid">
      <div class="row justify-content-center mt-1">
        <!-- MOBILE VIEW -->
        <div class="col-12 mt-5 pt-3">
          <div class="row">
            <div class="col-12 mt-2">
              <h3>Hostel Accomodation by Session</h3>
            </div>
          </div>
          <div class="row mt-3">
            <mat-accordion class="col-12">
              <mat-expansion-panel *ngFor="let session of sessionArr">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ session.session_year | uppercase }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
  
                <div class="row mb-2" *ngFor="let hostel of session.hostels">
                  <div class="col-12">
                    <strong>{{hostel.hostel_name}}</strong>
                    <strong class="float-right">{{hostel.total_amount | currency:'NGN':'symbol-narrow'}}</strong>
                  </div>
                  <div class="col-12">
                    <div class="row">
                        <div class="col-10">Fee</div>
                        <div class="col-2">Amount</div>
                    </div>
                    <div class="row" *ngFor="let fee of hostel.fees">
                        <div class="col-10"><small>{{fee.title}}</small></div>
                        <div class="col-2"><small>{{fee.amount}}</small></div>
                    </div>
                    <div class="row">
                        <div class="col-10"><strong>Total:</strong></div>
                        <div class="col-2"><strong>{{hostel.total_amount}}</strong></div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <button mat-raised-button color="primary" *ngIf="hostel.approved == 0" (click)="editHostel(session, hostel)">Edit Hostel in Request</button>
                        <button mat-raised-button class="btn-success" *ngIf="hostel.approved == 1" (click)="editHostel(session, hostel)">Approved</button>
                        <button mat-raised-button class="btn-danger" *ngIf="hostel.approved == 1" (click)="editHostel(session, hostel)">Rejected</button>
                      </div>
                    </div>
                  </div>
                </div>
                <p *ngIf="session.hostels.length == 0">
                  <button mat-raised-button color="primary" (click)="addHostel(session)">No Hostel Approved Yet, Request One</button>
                </p>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
  
      </div>
    </div>
    <div class="bottom">
      <!-- <button
        mat-fab
        class="material-icons actBtn"
        color="primary"
        (click)="addElectionOffice()"
        *ngIf="p_level == 'w' || p_level == 'd'"
      >
        <i class="material-icons">add</i>
      </button> -->
    </div>
  </mat-card-content>
  